import { useState, useEffect } from 'react'
import { useApi } from './useApi'

interface OrgResponse {
  name?: string
}

interface OrgUser {
  organizationId?: string
}

/**
 * 組織名を取得・管理するカスタムフック
 */
export function useOrganizationName(user: OrgUser | null): string {
  const api = useApi()
  const [orgName, setOrgName] = useState('ガンモ')

  useEffect(() => {
    const fetchOrgName = async () => {
      if (!user?.organizationId) return
      try {
        const data = await api.get<OrgResponse>('/api/organization')
        if (data?.name) {
          setOrgName(data.name)
        }
      } catch (err) {
        // 権限エラーなどは無視
      }
    }
    fetchOrgName()
  }, [api, user?.organizationId])

  return orgName
}
